import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Check, X } from 'lucide-react';

interface FollowConfirmationToastProps {
  label: string | null; // null = hidden
  onDismiss: () => void;
}

export function FollowConfirmationToast({ label, onDismiss }: FollowConfirmationToastProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!label) {
      setVisible(false);
      return;
    }
    setVisible(true);
    const timer = setTimeout(() => {
      setVisible(false);
      onDismiss();
    }, 4000);
    return () => clearTimeout(timer);
  }, [label, onDismiss]);

  if (!visible || !label) return null;

  return (
    <div className="fixed bottom-6 left-1/2 z-[100] -translate-x-1/2 animate-in fade-in slide-in-from-bottom-4 duration-300">
      <div className="flex items-center gap-3 rounded-2xl border border-primary-500/30 bg-gradient-to-r from-primary-500/90 to-primary-600/90 px-5 py-3 shadow-2xl backdrop-blur">
        <Check className="h-5 w-5 text-white" />
        <span className="text-sm font-bold text-white">
          Following {label}!
        </span>
        <Link
          to="/topics"
          onClick={onDismiss}
          className="ml-1 text-sm font-semibold text-white/90 underline underline-offset-2 hover:text-white"
        >
          Discover more topics →
        </Link>
        <button
          onClick={() => {
            setVisible(false);
            onDismiss();
          }}
          aria-label="Dismiss"
          className="ml-1 rounded-full p-1 text-white/70 hover:text-white hover:bg-white/10"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
